import { useForm } from "react-hook-form";
import { useUpdateMoveMutation, useGetMoveQuery } from "@/store/moves/apis";
import { Form } from "@/components/ui/form";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import CustomerInfo from "../EditMove/CustomerInfo";
import Service from "../EditMove/Service";
import Items from "../EditMove/Items";
import Billing from "../EditMove/Billing";
import Notes from "../EditMove/Notes";
import type { MoveInputs } from "@/types";
import { Addresses } from "../EditMove/Addresses";

export default function EditSection(props: {
  id: string;
  section:
    | "customer_info"
    | "service"
    | "items"
    | "billing"
    | "notes"
    | "addresses"
    | null;
  onClose: () => void;
}) {
  const { id, section, onClose } = props;

  const [updateMove] = useUpdateMoveMutation();
  const { data: existingMove, isLoading } = useGetMoveQuery(id, { skip: !id });

  const form = useForm<MoveInputs>({
    defaultValues: existingMove,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const onSubmit = async (data: MoveInputs) => {
    const cleanedPrimaryPhone = data.customer_mobile_phone.replace(/\D/g, "");
    const cleanedSecondaryPhone = data.customer_alternate_phone.replace(
      /\D/g,
      ""
    );
    const submitData = {
      ...data,
      mobile_phone: cleanedPrimaryPhone,
      alternate_phone: cleanedSecondaryPhone,
    };

    await updateMove({ id, move: submitData });
    onClose();
  };

  const getSectionTitle = () => {
    switch (section) {
      case "customer_info":
        return "Customer Information";
      case "service":
        return "Service Details";
      case "addresses":
        return "Addresses";
      case "items":
        return "Items";
      case "billing":
        return "Billing Information";
      case "notes":
        return "Notes";
      default:
        return "Edit Section";
    }
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{getSectionTitle()}</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            {section === "customer_info" && <CustomerInfo />}
            {section === "service" && <Service />}
            {section === "addresses" && <Addresses />}
            {section === "items" && <Items />}
            {section === "billing" && <Billing />}
            {section === "notes" && <Notes />}
            <DialogFooter>
              <Button type="submit">Save changes</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
}
